export interface GameLevel {
  id: number;
  title: string;
  theme: string;
  timeLimit: number;
  grids: GameGrid[];
}

export interface GameGrid {
  id: number;
  title: string;
  items: GameItem[];
}

export interface GameItem {
  id: string;
  name: string;
  emoji: string;
  searchQuery: string;
  imageUrl?: string;
  isFlipped?: boolean;
  isMatched?: boolean;
}

export const GAME_LEVELS: GameLevel[] = [
  {
    id: 1,
    title: "Le Tourisme",
    theme: "tourism",
    timeLimit: 90,
    grids: [
      {
        id: 1,
        title: "sites_touristiques",
        items: [
          { id: "lac_assal", name: "Lac Assal", emoji: "🏔️", searchQuery: "lake assal djibouti salt" },
          { id: "lac_abbe", name: "Lac Abbé", emoji: "🌋", searchQuery: "lake abbe djibouti volcanic" },
          { id: "khor_ambado", name: "Plage de Khor Ambado", emoji: "🏖️", searchQuery: "khor ambado beach djibouti" },
          { id: "moucha", name: "Îles Moucha", emoji: "🏝️", searchQuery: "moucha island djibouti coral" },
          { id: "doraleh", name: "Plage de Doraleh", emoji: "🏊", searchQuery: "doraleh beach djibouti" },
          { id: "goubet", name: "Goubet al Kharab", emoji: "⛵", searchQuery: "goubet kharab djibouti bay" },
          { id: "day_canyon", name: "Canyon de Day", emoji: "🏞️", searchQuery: "day forest canyon djibouti" },
          { id: "day_forest", name: "Forêt du Day", emoji: "🌲", searchQuery: "day forest djibouti mountains" }
        ]
      },
      {
        id: 2,
        title: "activites_touristiques",
        items: [
          { id: "diving", name: "Plongée", emoji: "🤿", searchQuery: "scuba diving red sea" },
          { id: "swimming", name: "Baignade", emoji: "🏊", searchQuery: "swimming tropical beach" },
          { id: "hiking", name: "Randonnée", emoji: "🥾", searchQuery: "hiking desert mountains" },
          { id: "flamingo", name: "Observation des flamants", emoji: "🦩", searchQuery: "flamingo watching wildlife" },
          { id: "boat_trip", name: "Excursion en bateau", emoji: "🛥️", searchQuery: "boat excursion african coast" },
          { id: "camping", name: "Camping", emoji: "⛺", searchQuery: "desert camping under stars" },
          { id: "guided_tour", name: "Tour guidé", emoji: "👨‍🏫", searchQuery: "guided tour african culture" },
          { id: "safari", name: "Safari photo", emoji: "📸", searchQuery: "photo safari african wildlife" }
        ]
      },
      {
        id: 3,
        title: "hotels_populaires",
        items: [
          { id: "sheraton", name: "Sheraton Djibouti", emoji: "🏨", searchQuery: "luxury hotel djibouti" },
          { id: "atlantic", name: "Atlantic Hotel", emoji: "🏨", searchQuery: "atlantic hotel djibouti" },
          { id: "kempinski", name: "Kempinski", emoji: "🏨", searchQuery: "kempinski hotel luxury" },
          { id: "acacias", name: "Acacias Hotel", emoji: "🏨", searchQuery: "hotel acacias africa" },
          { id: "sables_blancs", name: "Les Sables Blancs", emoji: "🏨", searchQuery: "white sand hotel beach" },
          { id: "ras_ali", name: "Ras Ali Hotel", emoji: "🏨", searchQuery: "ras ali hotel djibouti" },
          { id: "arta_beach", name: "Hotel Arta Beach", emoji: "🏨", searchQuery: "arta beach hotel djibouti" },
          { id: "europe", name: "Hotel Europe", emoji: "🏨", searchQuery: "hotel europe djibouti" }
        ]
      },
      {
        id: 4,
        title: "moyens_transport",
        items: [
          { id: "taxi", name: "Taxi", emoji: "🚕", searchQuery: "taxi african city" },
          { id: "minibus", name: "Minibus", emoji: "🚐", searchQuery: "minibus public transport africa" },
          { id: "plane", name: "Avion", emoji: "✈️", searchQuery: "airplane african airport" },
          { id: "train", name: "Train", emoji: "🚂", searchQuery: "train ethiopia djibouti railway" },
          { id: "ferry", name: "Ferry", emoji: "⛴️", searchQuery: "ferry red sea" },
          { id: "moto_taxi", name: "Moto-taxi", emoji: "🏍️", searchQuery: "motorcycle taxi africa" },
          { id: "rental_car", name: "Voiture de location", emoji: "🚗", searchQuery: "rental car african road" },
          { id: "bus", name: "Bus interurbain", emoji: "🚌", searchQuery: "intercity bus africa" }
        ]
      },
      {
        id: 5,
        title: "symboles_touristiques",
        items: [
          { id: "passport", name: "Passeport", emoji: "📔", searchQuery: "passport travel document" },
          { id: "camera", name: "Appareil photo", emoji: "📷", searchQuery: "camera photography travel" },
          { id: "map", name: "Carte de Djibouti", emoji: "🗺️", searchQuery: "djibouti map africa" },
          { id: "backpack", name: "Sac à dos", emoji: "🎒", searchQuery: "backpack travel adventure" },
          { id: "binoculars", name: "Jumelles", emoji: "🔭", searchQuery: "binoculars wildlife watching" },
          { id: "compass", name: "Boussole", emoji: "🧭", searchQuery: "compass navigation desert" },
          { id: "sunscreen", name: "Crème solaire", emoji: "🧴", searchQuery: "sunscreen tropical sun" },
          { id: "cap", name: "Casquette", emoji: "🧢", searchQuery: "cap hat sun protection" }
        ]
      }
    ]
  },
  {
    id: 2,
    title: "La Culture",
    theme: "culture",
    timeLimit: 85,
    grids: [
      {
        id: 6,
        title: "langues_parlees",
        items: [
          { id: "somali", name: "Somali", emoji: "🗣️", searchQuery: "somali language africa" },
          { id: "afar", name: "Afar", emoji: "🗣️", searchQuery: "afar people language ethiopia" },
          { id: "arabic", name: "Arabe", emoji: "🗣️", searchQuery: "arabic language script" },
          { id: "french", name: "Français", emoji: "🗣️", searchQuery: "french language africa" },
          { id: "english", name: "Anglais", emoji: "🗣️", searchQuery: "english language learning" },
          { id: "italian", name: "Italien", emoji: "🗣️", searchQuery: "italian language mediterranean" },
          { id: "swahili", name: "Swahili", emoji: "🗣️", searchQuery: "swahili language east africa" },
          { id: "oromo", name: "Oromo", emoji: "🗣️", searchQuery: "oromo language ethiopia" }
        ]
      },
      {
        id: 7,
        title: "fetes_nationales",
        items: [
          { id: "independence", name: "Fête de l'Indépendance", emoji: "🇩🇯", searchQuery: "djibouti independence flag celebration" },
          { id: "ramadan", name: "Ramadan", emoji: "🌙", searchQuery: "ramadan crescent moon islamic" },
          { id: "eid_fitr", name: "Aïd el-Fitr", emoji: "🎉", searchQuery: "eid celebration islamic festival" },
          { id: "eid_adha", name: "Aïd el-Adha", emoji: "🐑", searchQuery: "eid adha sacrifice islamic" },
          { id: "mawlid", name: "Maoulid", emoji: "🕌", searchQuery: "mawlid prophet birthday islamic" },
          { id: "teachers_day", name: "Fête des enseignants", emoji: "👨‍🏫", searchQuery: "teachers day education" },
          { id: "womens_day", name: "Journée des femmes", emoji: "👩", searchQuery: "womens day celebration" },
          { id: "language_day", name: "Journée de la langue", emoji: "📚", searchQuery: "language day cultural celebration" }
        ]
      },
      {
        id: 8,
        title: "symboles_nationaux",
        items: [
          { id: "flag", name: "Drapeau", emoji: "🇩🇯", searchQuery: "djibouti flag national symbol" },
          { id: "emblem", name: "Emblème", emoji: "🛡️", searchQuery: "national emblem coat arms" },
          { id: "anthem", name: "Hymne", emoji: "🎵", searchQuery: "national anthem music" },
          { id: "map_symbol", name: "Carte", emoji: "🗺️", searchQuery: "djibouti map horn africa" },
          { id: "president", name: "Président", emoji: "👤", searchQuery: "president government leader" },
          { id: "constitution", name: "Constitution", emoji: "📜", searchQuery: "constitution legal document" },
          { id: "monument", name: "Monument", emoji: "🗿", searchQuery: "national monument memorial" },
          { id: "motto", name: "Devise nationale", emoji: "💭", searchQuery: "national motto unity" }
        ]
      },
      {
        id: 9,
        title: "personnages_celebres",
        items: [
          { id: "hassan_gouled", name: "Hassan Gouled", emoji: "👨", searchQuery: "hassan gouled djibouti president" },
          { id: "ismail_omar", name: "Ismaïl Omar", emoji: "👨", searchQuery: "ismail omar djibouti politician" },
          { id: "hawa_aden", name: "Hawa Aden", emoji: "👩", searchQuery: "hawa aden djibouti woman leader" },
          { id: "aden_elmi", name: "Aden Elmi", emoji: "👨", searchQuery: "aden elmi djibouti" },
          { id: "dini_mohamed", name: "Dini Mohamed", emoji: "👨", searchQuery: "dini mohamed djibouti" },
          { id: "barkat_gourad", name: "Barkat Gourad", emoji: "👨", searchQuery: "barkat gourad djibouti" },
          { id: "waberi", name: "Abdourahman Waberi", emoji: "👨", searchQuery: "abdourahman waberi writer djibouti" },
          { id: "kamil", name: "Kamil D.", emoji: "👨", searchQuery: "kamil djibouti personality" }
        ]
      },
      {
        id: 10,
        title: "lieux_culturels",
        items: [
          { id: "institut_francais", name: "Institut Français", emoji: "🏛️", searchQuery: "institut francais cultural center" },
          { id: "centre_arabe", name: "Centre culturel arabe", emoji: "🏛️", searchQuery: "arabic cultural center" },
          { id: "alliance_franco", name: "Alliance Franco-Djiboutienne", emoji: "🏛️", searchQuery: "french alliance cultural" },
          { id: "musee_regional", name: "Musée régional", emoji: "🏛️", searchQuery: "regional museum africa" },
          { id: "bibliotheque", name: "Bibliothèque nationale", emoji: "📚", searchQuery: "national library books" },
          { id: "theatre", name: "Théâtre", emoji: "🎭", searchQuery: "theatre performing arts" },
          { id: "galerie_art", name: "Galerie d'art", emoji: "🖼️", searchQuery: "art gallery african art" },
          { id: "maison_patrimoine", name: "Maison du patrimoine", emoji: "🏛️", searchQuery: "heritage house cultural" }
        ]
      }
    ]
  },
  {
    id: 3,
    title: "La Cuisine",
    theme: "food",
    timeLimit: 80,
    grids: [
      {
        id: 11,
        title: "plats_traditionnels",
        items: [
          { id: "skoudehkaris", name: "Skoudehkaris", emoji: "🍛", searchQuery: "skoudehkaris djibouti rice dish" },
          { id: "fah_fah", name: "Fah-Fah", emoji: "🍲", searchQuery: "fah fah soup djibouti" },
          { id: "lahoh", name: "Lahoh", emoji: "🥞", searchQuery: "lahoh pancake somali" },
          { id: "sambuusa", name: "Sambuusa", emoji: "🥟", searchQuery: "sambuusa samosa african" },
          { id: "banana_fritters", name: "Beignets de banane", emoji: "🍌", searchQuery: "banana fritters african" },
          { id: "dates", name: "Dattes", emoji: "🌴", searchQuery: "dates fruit middle eastern" },
          { id: "maraq", name: "Maraq", emoji: "🍲", searchQuery: "maraq somali soup" },
          { id: "halwa", name: "Halwa", emoji: "🍬", searchQuery: "halwa sweet middle eastern" }
        ]
      },
      {
        id: 12,
        title: "boissons_locales",
        items: [
          { id: "camel_milk", name: "Lait de chamelle", emoji: "🐪", searchQuery: "camel milk traditional" },
          { id: "tea", name: "Thé à la menthe", emoji: "🍵", searchQuery: "mint tea arabic" },
          { id: "coffee", name: "Café", emoji: "☕", searchQuery: "ethiopian coffee ceremony" },
          { id: "tamarind", name: "Jus de tamarin", emoji: "🥤", searchQuery: "tamarind juice african" },
          { id: "ginger_drink", name: "Boisson au gingembre", emoji: "🥤", searchQuery: "ginger drink african" },
          { id: "hibiscus", name: "Thé d'hibiscus", emoji: "🌺", searchQuery: "hibiscus tea african" },
          { id: "lemonade", name: "Citronnade", emoji: "🍋", searchQuery: "homemade lemonade" },
          { id: "coconut", name: "Eau de coco", emoji: "🥥", searchQuery: "coconut water tropical" }
        ]
      },
      {
        id: 13,
        title: "ingredients_base",
        items: [
          { id: "rice", name: "Riz", emoji: "🍚", searchQuery: "rice staple food" },
          { id: "sorghum", name: "Sorgho", emoji: "🌾", searchQuery: "sorghum grain african" },
          { id: "goat", name: "Viande de chèvre", emoji: "🐐", searchQuery: "goat meat african" },
          { id: "camel", name: "Viande de chameau", emoji: "🐪", searchQuery: "camel meat middle eastern" },
          { id: "fish", name: "Poisson", emoji: "🐟", searchQuery: "red sea fish" },
          { id: "lentils", name: "Lentilles", emoji: "🥣", searchQuery: "lentils legumes" },
          { id: "onions", name: "Oignons", emoji: "🧅", searchQuery: "onions cooking ingredient" },
          { id: "tomatoes", name: "Tomates", emoji: "🍅", searchQuery: "tomatoes fresh vegetable" }
        ]
      },
      {
        id: 14,
        title: "epices_condiments",
        items: [
          { id: "berbere", name: "Berbere", emoji: "🌶️", searchQuery: "berbere spice mix ethiopian" },
          { id: "cumin", name: "Cumin", emoji: "🌱", searchQuery: "cumin seeds spice" },
          { id: "cardamom", name: "Cardamome", emoji: "🌱", searchQuery: "cardamom pods spice" },
          { id: "cinnamon", name: "Cannelle", emoji: "🌿", searchQuery: "cinnamon sticks spice" },
          { id: "cloves", name: "Clous de girofle", emoji: "🌱", searchQuery: "cloves spice" },
          { id: "turmeric", name: "Curcuma", emoji: "🌾", searchQuery: "turmeric powder spice" },
          { id: "chili", name: "Piment", emoji: "🌶️", searchQuery: "chili pepper spice" },
          { id: "garlic", name: "Ail", emoji: "🧄", searchQuery: "garlic cooking ingredient" }
        ]
      },
      {
        id: 15,
        title: "desserts_sucreries",
        items: [
          { id: "baklava", name: "Baklava", emoji: "🍯", searchQuery: "baklava middle eastern dessert" },
          { id: "basbousa", name: "Basbousa", emoji: "🍰", searchQuery: "basbousa semolina cake" },
          { id: "dates_honey", name: "Dattes au miel", emoji: "🍯", searchQuery: "dates with honey dessert" },
          { id: "halwa_2", name: "Halwa aux noix", emoji: "🥜", searchQuery: "halwa nuts dessert" },
          { id: "kunafa", name: "Kunafa", emoji: "🧀", searchQuery: "kunafa cheese dessert" },
          { id: "luqaimat", name: "Luqaimat", emoji: "🍩", searchQuery: "luqaimat arabic dumplings" },
          { id: "maamoul", name: "Maamoul", emoji: "🍪", searchQuery: "maamoul date cookies" },
          { id: "qatayef", name: "Qatayef", emoji: "🥮", searchQuery: "qatayef arabic pancakes" }
        ]
      }
    ]
  },
  {
    id: 4,
    title: "La Faune et Flore",
    theme: "nature",
    timeLimit: 75,
    grids: [
      {
        id: 16,
        title: "animaux_terrestres",
        items: [
          { id: "dorcas_gazelle", name: "Gazelle dorcas", emoji: "🦌", searchQuery: "dorcas gazelle africa" },
          { id: "oryx", name: "Oryx", emoji: "🦌", searchQuery: "oryx antelope horn africa" },
          { id: "hamadryas_baboon", name: "Babouin hamadryas", emoji: "🐒", searchQuery: "hamadryas baboon africa" },
          { id: "salt_donkey", name: "Âne du sel", emoji: "🐴", searchQuery: "salt donkey djibouti" },
          { id: "dik_dik", name: "Dik-dik", emoji: "🦌", searchQuery: "dik dik small antelope" },
          { id: "hyena", name: "Hyène", emoji: "🐺", searchQuery: "hyena africa predator" },
          { id: "jackal", name: "Chacal", emoji: "🐺", searchQuery: "jackal africa canine" },
          { id: "warthog", name: "Phacochère", emoji: "🐗", searchQuery: "warthog africa wild pig" }
        ]
      },
      {
        id: 17,
        title: "oiseaux",
        items: [
          { id: "flamingo", name: "Flamant rose", emoji: "🦩", searchQuery: "flamingo lake abbe djibouti" },
          { id: "pelican", name: "Pélican", emoji: "🐦", searchQuery: "pelican african bird" },
          { id: "ostrich", name: "Autruche", emoji: "🐦", searchQuery: "ostrich african bird" },
          { id: "hornbill", name: "Calao", emoji: "🐦", searchQuery: "hornbill african bird" },
          { id: "vulture", name: "Vautour", emoji: "🦅", searchQuery: "vulture african bird" },
          { id: "secretary_bird", name: "Messager sagittaire", emoji: "🦅", searchQuery: "secretary bird africa" },
          { id: "sunbird", name: "Souimanga", emoji: "🐦", searchQuery: "sunbird african small" },
          { id: "bustard", name: "Outarde", emoji: "🐦", searchQuery: "bustard african bird" }
        ]
      },
      {
        id: 18,
        title: "vie_marine",
        items: [
          { id: "whale_shark", name: "Requin-baleine", emoji: "🦈", searchQuery: "whale shark red sea" },
          { id: "dolphin", name: "Dauphin", emoji: "🐬", searchQuery: "dolphin red sea" },
          { id: "turtle", name: "Tortue marine", emoji: "🐢", searchQuery: "sea turtle red sea" },
          { id: "manta_ray", name: "Raie manta", emoji: "🐠", searchQuery: "manta ray red sea" },
          { id: "coral", name: "Corail", emoji: "🪸", searchQuery: "coral reef red sea" },
          { id: "parrotfish", name: "Poisson-perroquet", emoji: "🐠", searchQuery: "parrotfish colorful reef" },
          { id: "lionfish", name: "Poisson-lion", emoji: "🐡", searchQuery: "lionfish venomous reef" },
          { id: "octopus", name: "Poulpe", emoji: "🐙", searchQuery: "octopus red sea" }
        ]
      },
      {
        id: 19,
        title: "reptiles_insectes",
        items: [
          { id: "lizard", name: "Lézard", emoji: "🦎", searchQuery: "desert lizard africa" },
          { id: "snake", name: "Serpent", emoji: "🐍", searchQuery: "african desert snake" },
          { id: "scorpion", name: "Scorpion", emoji: "🦂", searchQuery: "desert scorpion africa" },
          { id: "beetle", name: "Scarabée", emoji: "🪲", searchQuery: "desert beetle africa" },
          { id: "butterfly", name: "Papillon", emoji: "🦋", searchQuery: "african butterfly colorful" },
          { id: "locust", name: "Criquet", emoji: "🦗", searchQuery: "desert locust africa" },
          { id: "gecko", name: "Gecko", emoji: "🦎", searchQuery: "gecko lizard africa" },
          { id: "chameleon", name: "Caméléon", emoji: "🦎", searchQuery: "chameleon africa reptile" }
        ]
      },
      {
        id: 20,
        title: "flore_locale",
        items: [
          { id: "acacia", name: "Acacia", emoji: "🌳", searchQuery: "acacia tree africa" },
          { id: "doum_palm", name: "Palmier doum", emoji: "🌴", searchQuery: "doum palm tree africa" },
          { id: "baobab", name: "Baobab", emoji: "🌳", searchQuery: "baobab tree africa" },
          { id: "aloe", name: "Aloès", emoji: "🌵", searchQuery: "aloe vera plant africa" },
          { id: "euphorbia", name: "Euphorbe", emoji: "🌵", searchQuery: "euphorbia plant africa" },
          { id: "desert_rose", name: "Rose du désert", emoji: "🌹", searchQuery: "desert rose adenium" },
          { id: "juniper", name: "Genévrier", emoji: "🌲", searchQuery: "juniper tree africa" },
          { id: "wild_olive", name: "Olivier sauvage", emoji: "🫒", searchQuery: "wild olive tree africa" }
        ]
      }
    ]
  },
  {
    id: 5,
    title: "Les Régions",
    theme: "regions",
    timeLimit: 70,
    grids: [
      {
        id: 21,
        title: "villes_principales",
        items: [
          { id: "djibouti_city", name: "Djibouti-ville", emoji: "🏙️", searchQuery: "djibouti city capital" },
          { id: "ali_sabieh", name: "Ali Sabieh", emoji: "🏙️", searchQuery: "ali sabieh djibouti city" },
          { id: "dikhil", name: "Dikhil", emoji: "🏙️", searchQuery: "dikhil djibouti city" },
          { id: "tadjourah", name: "Tadjourah", emoji: "🏙️", searchQuery: "tadjourah djibouti city" },
          { id: "obock", name: "Obock", emoji: "🏙️", searchQuery: "obock djibouti city" },
          { id: "arta", name: "Arta", emoji: "🏙️", searchQuery: "arta djibouti city" },
          { id: "holhol", name: "Holhol", emoji: "🏙️", searchQuery: "holhol djibouti town" },
          { id: "day", name: "Day", emoji: "🏙️", searchQuery: "day djibouti town" }
        ]
      },
      {
        id: 22,
        title: "regions_administratives",
        items: [
          { id: "djibouti_region", name: "Région de Djibouti", emoji: "🗺️", searchQuery: "djibouti region map" },
          { id: "ali_sabieh_region", name: "Région d'Ali Sabieh", emoji: "🗺️", searchQuery: "ali sabieh region djibouti" },
          { id: "dikhil_region", name: "Région de Dikhil", emoji: "🗺️", searchQuery: "dikhil region djibouti" },
          { id: "tadjourah_region", name: "Région de Tadjourah", emoji: "🗺️", searchQuery: "tadjourah region djibouti" },
          { id: "obock_region", name: "Région d'Obock", emoji: "🗺️", searchQuery: "obock region djibouti" },
          { id: "arta_region", name: "Région d'Arta", emoji: "🗺️", searchQuery: "arta region djibouti" },
          { id: "districts", name: "Districts", emoji: "🗺️", searchQuery: "djibouti districts map" },
          { id: "borders", name: "Frontières", emoji: "🗺️", searchQuery: "djibouti borders map" }
        ]
      },
      {
        id: 23,
        title: "caracteristiques_geographiques",
        items: [
          { id: "mountains", name: "Montagnes Goda", emoji: "⛰️", searchQuery: "goda mountains djibouti" },
          { id: "grand_bara", name: "Grand Bara", emoji: "🏜️", searchQuery: "grand bara desert djibouti" },
          { id: "gulf_tadjoura", name: "Golfe de Tadjoura", emoji: "🌊", searchQuery: "gulf tadjoura djibouti" },
          { id: "bab_el_mandeb", name: "Bab el-Mandeb", emoji: "🌊", searchQuery: "bab el mandeb strait" },
          { id: "ghoubbet", name: "Ghoubbet al-Kharab", emoji: "🌊", searchQuery: "ghoubbet kharab bay djibouti" },
          { id: "day_forest_region", name: "Forêt du Day", emoji: "🌲", searchQuery: "day forest djibouti" },
          { id: "ardoukoba", name: "Ardoukoba", emoji: "🌋", searchQuery: "ardoukoba volcano djibouti" },
          { id: "salt_plains", name: "Plaines de sel", emoji: "⚪", searchQuery: "salt plains djibouti" }
        ]
      },
      {
        id: 24,
        title: "quartiers_djibouti_ville",
        items: [
          { id: "plateau", name: "Le Plateau", emoji: "🏙️", searchQuery: "plateau district djibouti city" },
          { id: "heron", name: "Héron", emoji: "🏙️", searchQuery: "heron district djibouti city" },
          { id: "balbala", name: "Balbala", emoji: "🏙️", searchQuery: "balbala district djibouti city" },
          { id: "ambouli", name: "Ambouli", emoji: "🏙️", searchQuery: "ambouli district djibouti city" },
          { id: "arhiba", name: "Arhiba", emoji: "🏙️", searchQuery: "arhiba district djibouti city" },
          { id: "boulaos", name: "Boulaos", emoji: "🏙️", searchQuery: "boulaos district djibouti city" },
          { id: "gabode", name: "Gabode", emoji: "🏙️", searchQuery: "gabode district djibouti city" },
          { id: "einguela", name: "Einguela", emoji: "🏙️", searchQuery: "einguela district djibouti city" }
        ]
      },
      {
        id: 25,
        title: "infrastructures_regionales",
        items: [
          { id: "port", name: "Port de Djibouti", emoji: "🚢", searchQuery: "djibouti port container" },
          { id: "airport", name: "Aéroport international", emoji: "✈️", searchQuery: "djibouti international airport" },
          { id: "railway", name: "Chemin de fer", emoji: "🚂", searchQuery: "ethiopia djibouti railway" },
          { id: "dam", name: "Barrage d'Ambouli", emoji: "🏞️", searchQuery: "ambouli dam djibouti" },
          { id: "hospital", name: "Hôpital Peltier", emoji: "🏥", searchQuery: "peltier hospital djibouti" },
          { id: "university", name: "Université de Djibouti", emoji: "🏫", searchQuery: "university djibouti" },
          { id: "stadium", name: "Stade du Gouled", emoji: "🏟️", searchQuery: "gouled stadium djibouti" },
          { id: "palace", name: "Palais présidentiel", emoji: "🏛️", searchQuery: "presidential palace djibouti" }
        ]
      }
    ]
  },
  {
    id: 6,
    title: "Le Commerce",
    theme: "commerce",
    timeLimit: 65,
    grids: [
      {
        id: 26,
        title: "secteurs_economiques",
        items: [
          { id: "port_services", name: "Services portuaires", emoji: "🚢", searchQuery: "djibouti port services" },
          { id: "logistics", name: "Logistique", emoji: "🚚", searchQuery: "logistics transport djibouti" },
          { id: "banking", name: "Banques", emoji: "🏦", searchQuery: "banking sector djibouti" },
          { id: "telecom", name: "Télécommunications", emoji: "📱", searchQuery: "telecommunications djibouti" },
          { id: "tourism", name: "Tourisme", emoji: "🏖️", searchQuery: "tourism sector djibouti" },
          { id: "energy", name: "Énergie", emoji: "⚡", searchQuery: "energy sector djibouti" },
          { id: "fishing", name: "Pêche", emoji: "🎣", searchQuery: "fishing industry djibouti" },
          { id: "salt_industry", name: "Industrie du sel", emoji: "🧂", searchQuery: "salt industry djibouti" }
        ]
      },
      {
        id: 27,
        title: "marches_locaux",
        items: [
          { id: "central_market", name: "Marché central", emoji: "🛒", searchQuery: "central market djibouti" },
          { id: "livestock_market", name: "Marché au bétail", emoji: "🐑", searchQuery: "livestock market africa" },
          { id: "fish_market", name: "Marché aux poissons", emoji: "🐟", searchQuery: "fish market djibouti" },
          { id: "khat_market", name: "Marché du khat", emoji: "🌿", searchQuery: "khat market horn africa" },
          { id: "textile_market", name: "Marché textile", emoji: "🧵", searchQuery: "textile market africa" },
          { id: "spice_market", name: "Marché aux épices", emoji: "🌶️", searchQuery: "spice market africa" },
          { id: "handicraft_market", name: "Marché artisanal", emoji: "🏺", searchQuery: "handicraft market africa" },
          { id: "night_market", name: "Marché nocturne", emoji: "🌙", searchQuery: "night market africa" }
        ]
      },
      {
        id: 28,
        title: "produits_exportation",
        items: [
          { id: "salt_export", name: "Sel", emoji: "🧂", searchQuery: "salt export djibouti" },
          { id: "livestock_export", name: "Bétail", emoji: "🐄", searchQuery: "livestock export horn africa" },
          { id: "hides_skins", name: "Peaux et cuirs", emoji: "🧳", searchQuery: "hides skins export africa" },
          { id: "coffee_transit", name: "Café (transit)", emoji: "☕", searchQuery: "coffee export ethiopia" },
          { id: "frankincense", name: "Encens", emoji: "💨", searchQuery: "frankincense export africa" },
          { id: "myrrh", name: "Myrrhe", emoji: "💨", searchQuery: "myrrh export africa" },
          { id: "pearls", name: "Perles", emoji: "🦪", searchQuery: "pearls red sea export" },
          { id: "handicrafts", name: "Artisanat", emoji: "🏺", searchQuery: "handicrafts export africa" }
        ]
      },
      {
        id: 29,
        title: "entreprises_locales",
        items: [
          { id: "djibouti_telecom", name: "Djibouti Telecom", emoji: "📞", searchQuery: "djibouti telecom company" },
          { id: "electricity_djibouti", name: "Électricité de Djibouti", emoji: "💡", searchQuery: "electricity djibouti company" },
          { id: "port_authority", name: "Autorité des Ports", emoji: "🚢", searchQuery: "djibouti port authority" },
          { id: "air_djibouti", name: "Air Djibouti", emoji: "✈️", searchQuery: "air djibouti airline" },
          { id: "great_horn_bank", name: "Great Horn Bank", emoji: "🏦", searchQuery: "great horn bank djibouti" },
          { id: "djibouti_shipping", name: "Djibouti Shipping", emoji: "🚢", searchQuery: "djibouti shipping company" },
          { id: "red_sea_bottling", name: "Red Sea Bottling", emoji: "🥤", searchQuery: "bottling company africa" },
          { id: "salt_investment", name: "Salt Investment", emoji: "🧂", searchQuery: "salt company djibouti" }
        ]
      },
      {
        id: 30,
        title: "monnaie_finances",
        items: [
          { id: "djibouti_franc", name: "Franc djiboutien", emoji: "💰", searchQuery: "djibouti franc currency" },
          { id: "central_bank", name: "Banque centrale", emoji: "🏦", searchQuery: "central bank djibouti" },
          { id: "money_exchange", name: "Bureau de change", emoji: "💱", searchQuery: "money exchange office" },
          { id: "mobile_money", name: "Argent mobile", emoji: "📱", searchQuery: "mobile money africa" },
          { id: "microfinance", name: "Microfinance", emoji: "💳", searchQuery: "microfinance africa" },
          { id: "stock_exchange", name: "Bourse", emoji: "📈", searchQuery: "stock exchange africa" },
          { id: "insurance", name: "Assurance", emoji: "🔒", searchQuery: "insurance company africa" },
          { id: "taxation", name: "Fiscalité", emoji: "📝", searchQuery: "taxation system africa" }
        ]
      }
    ]
  },
  {
    id: 7,
    title: "Les Traditions",
    theme: "traditions",
    timeLimit: 60,
    grids: [
      {
        id: 31,
        title: "vetements_traditionnels",
        items: [
          { id: "dirac", name: "Dirac", emoji: "👗", searchQuery: "dirac somali traditional dress" },
          { id: "macawiis", name: "Macawiis", emoji: "👖", searchQuery: "macawiis somali traditional" },
          { id: "koofiyad", name: "Koofiyad", emoji: "👒", searchQuery: "koofiyad somali hat" },
          { id: "garbasaar", name: "Garbasaar", emoji: "🧣", searchQuery: "garbasaar somali scarf" },
          { id: "guntino", name: "Guntino", emoji: "👘", searchQuery: "guntino afar traditional dress" },
          { id: "shash", name: "Shash", emoji: "👳", searchQuery: "shash turban african" },
          { id: "khamis", name: "Khamis", emoji: "👕", searchQuery: "khamis traditional shirt" },
          { id: "jewelry", name: "Bijoux traditionnels", emoji: "💍", searchQuery: "traditional african jewelry" }
        ]
      },
      {
        id: 32,
        title: "danses_traditionnelles",
        items: [
          { id: "dhaanto", name: "Dhaanto", emoji: "💃", searchQuery: "dhaanto somali dance" },
          { id: "saylici", name: "Saylici", emoji: "🕺", searchQuery: "saylici traditional dance" },
          { id: "afar_dance", name: "Danse Afar", emoji: "💃", searchQuery: "afar traditional dance" },
          { id: "jenile", name: "Jenile", emoji: "🕺", searchQuery: "jenile traditional dance" },
          { id: "shakara", name: "Shakara", emoji: "💃", searchQuery: "shakara dance african" },
          { id: "warrior_dance", name: "Danse des guerriers", emoji: "🕺", searchQuery: "african warrior dance" },
          { id: "wedding_dance", name: "Danse nuptiale", emoji: "👰", searchQuery: "african wedding dance" },
          { id: "drum_dance", name: "Danse des tambours", emoji: "🥁", searchQuery: "african drum dance" }
        ]
      },
      {
        id: 33,
        title: "musique_traditionnelle",
        items: [
          { id: "oud", name: "Oud", emoji: "🎸", searchQuery: "oud arabic instrument" },
          { id: "dumbek", name: "Dumbek", emoji: "🥁", searchQuery: "dumbek drum arabic" },
          { id: "kaban", name: "Kaban", emoji: "🥁", searchQuery: "kaban african drum" },
          { id: "masinko", name: "Masinko", emoji: "🎻", searchQuery: "masinko ethiopian instrument" },
          { id: "flute", name: "Flûte traditionnelle", emoji: "🎵", searchQuery: "traditional african flute" },
          { id: "folk_songs", name: "Chants populaires", emoji: "🎤", searchQuery: "african folk songs" },
          { id: "wedding_songs", name: "Chants de mariage", emoji: "👰", searchQuery: "african wedding songs" },
          { id: "work_songs", name: "Chants de travail", emoji: "🛠️", searchQuery: "african work songs" }
        ]
      },
      {
        id: 34,
        title: "ceremonies",
        items: [
          { id: "wedding", name: "Mariage traditionnel", emoji: "💍", searchQuery: "traditional african wedding" },
          { id: "birth_ceremony", name: "Cérémonie de naissance", emoji: "👶", searchQuery: "african birth ceremony" },
          { id: "naming_ceremony", name: "Cérémonie du nom", emoji: "📝", searchQuery: "african naming ceremony" },
          { id: "coming_of_age", name: "Rite de passage", emoji: "👦", searchQuery: "african coming of age ceremony" },
          { id: "funeral", name: "Funérailles", emoji: "🕯️", searchQuery: "african traditional funeral" },
          { id: "harvest_ceremony", name: "Fête des récoltes", emoji: "🌾", searchQuery: "african harvest ceremony" },
          { id: "blessing_ceremony", name: "Cérémonie de bénédiction", emoji: "🙏", searchQuery: "african blessing ceremony" },
          { id: "peace_ceremony", name: "Cérémonie de paix", emoji: "☮️", searchQuery: "african peace ceremony" }
        ]
      },
      {
        id: 35,
        title: "artisanat_traditionnel",
        items: [
          { id: "basket_weaving", name: "Vannerie", emoji: "🧺", searchQuery: "african basket weaving" },
          { id: "pottery", name: "Poterie", emoji: "🏺", searchQuery: "african traditional pottery" },
          { id: "leatherwork", name: "Maroquinerie", emoji: "🧳", searchQuery: "african traditional leatherwork" },
          { id: "beadwork", name: "Perlage", emoji: "📿", searchQuery: "african beadwork craft" },
          { id: "woodcarving", name: "Sculpture sur bois", emoji: "🪵", searchQuery: "african wood carving" },
          { id: "weaving", name: "Tissage", emoji: "🧵", searchQuery: "african traditional weaving" },
          { id: "jewelry_making", name: "Bijouterie", emoji: "💍", searchQuery: "african traditional jewelry making" },
          { id: "calabash_art", name: "Art de la calebasse", emoji: "🥣", searchQuery: "african calabash art" }
        ]
      }
    ]
  },
  {
    id: 8,
    title: "L'Histoire",
    theme: "history",
    timeLimit: 55,
    grids: [
      {
        id: 36,
        title: "periodes_historiques",
        items: [
          { id: "ancient_period", name: "Période ancienne", emoji: "🏛️", searchQuery: "ancient djibouti history" },
          { id: "islamic_influence", name: "Influence islamique", emoji: "☪️", searchQuery: "islamic influence horn africa" },
          { id: "ottoman_period", name: "Période ottomane", emoji: "🏯", searchQuery: "ottoman empire horn africa" },
          { id: "french_colony", name: "Colonie française", emoji: "🇫🇷", searchQuery: "french somaliland colony" },
          { id: "independence_movement", name: "Mouvement d'indépendance", emoji: "✊", searchQuery: "djibouti independence movement" },
          { id: "independence", name: "Indépendance", emoji: "🇩🇯", searchQuery: "djibouti independence 1977" },
          { id: "modern_era", name: "Ère moderne", emoji: "🏙️", searchQuery: "modern djibouti development" },
          { id: "civil_conflicts", name: "Conflits civils", emoji: "⚔️", searchQuery: "djibouti civil conflicts" }
        ]
      },
      {
        id: 37,
        title: "personnages_historiques",
        items: [
          { id: "hassan_gouled_aptidon", name: "Hassan Gouled Aptidon", emoji: "👨‍💼", searchQuery: "hassan gouled aptidon president" },
          { id: "mahmoud_harbi", name: "Mahmoud Harbi", emoji: "👨‍💼", searchQuery: "mahmoud harbi djibouti politician" },
          { id: "mahamoud_ahmed", name: "Mahamoud Ahmed", emoji: "👨‍💼", searchQuery: "mahamoud ahmed djibouti history" },
          { id: "aref_bourhan", name: "Aref Bourhan", emoji: "👨‍💼", searchQuery: "aref bourhan djibouti history" },
          { id: "aicha_bogoreh", name: "Aicha Bogoreh", emoji: "👩‍💼", searchQuery: "aicha bogoreh djibouti woman" },
          { id: "ismail_omar_guelleh", name: "Ismail Omar Guelleh", emoji: "👨‍💼", searchQuery: "ismail omar guelleh president" },
          { id: "ahmed_dini", name: "Ahmed Dini", emoji: "👨‍💼", searchQuery: "ahmed dini djibouti politician" },
          { id: "barkat_gourad", name: "Barkat Gourad Hamadou", emoji: "👨‍💼", searchQuery: "barkat gourad hamadou djibouti" }
        ]
      },
      {
        id: 38,
        title: "sites_historiques",
        items: [
          { id: "tadjoura_mosque", name: "Mosquée de Tadjoura", emoji: "🕌", searchQuery: "tadjoura mosque djibouti" },
          { id: "ambouli_gardens", name: "Jardins d'Ambouli", emoji: "🌳", searchQuery: "ambouli gardens djibouti" },
          { id: "governor_palace", name: "Palais du Gouverneur", emoji: "🏛️", searchQuery: "governor palace djibouti" },
          { id: "old_port", name: "Vieux port", emoji: "⚓", searchQuery: "old port djibouti history" },
          { id: "menelik_square", name: "Place Menelik", emoji: "🏛️", searchQuery: "menelik square djibouti" },
          { id: "hamoudi_mosque", name: "Mosquée Hamoudi", emoji: "🕌", searchQuery: "hamoudi mosque djibouti" },
          { id: "railway_station", name: "Ancienne gare", emoji: "🚂", searchQuery: "old railway station djibouti" },
          { id: "european_quarter", name: "Quartier européen", emoji: "🏛️", searchQuery: "european quarter djibouti" }
        ]
      },
      {
        id: 39,
        title: "evenements_historiques",
        items: [
          { id: "treaty_1862", name: "Traité de 1862", emoji: "📜", searchQuery: "treaty 1862 obock france" },
          { id: "french_somaliland", name: "Côte française des Somalis", emoji: "🇫🇷", searchQuery: "french somaliland colony" },
          { id: "referendum_1967", name: "Référendum de 1967", emoji: "🗳️", searchQuery: "djibouti referendum 1967" },
          { id: "independence_1977", name: "Indépendance 1977", emoji: "🇩🇯", searchQuery: "djibouti independence 1977" },
          { id: "civil_war", name: "Guerre civile", emoji: "⚔️", searchQuery: "djibouti civil war 1990s" },
          { id: "peace_accord", name: "Accord de paix", emoji: "🕊️", searchQuery: "djibouti peace accord" },
          { id: "constitution", name: "Constitution", emoji: "📜", searchQuery: "djibouti constitution" },
          { id: "multiparty_system", name: "Système multipartite", emoji: "🗳️", searchQuery: "djibouti multiparty system" }
        ]
      },
      {
        id: 40,
        title: "artefacts_historiques",
        items: [
          { id: "rock_art", name: "Art rupestre", emoji: "🖼️", searchQuery: "rock art djibouti prehistoric" },
          { id: "ancient_tools", name: "Outils anciens", emoji: "🔨", searchQuery: "ancient tools horn africa" },
          { id: "pottery_artifacts", name: "Poteries anciennes", emoji: "🏺", searchQuery: "ancient pottery horn africa" },
          { id: "manuscripts", name: "Manuscrits", emoji: "📜", searchQuery: "ancient manuscripts horn africa" },
          { id: "coins", name: "Pièces de monnaie", emoji: "🪙", searchQuery: "ancient coins horn africa" },
          { id: "weapons", name: "Armes traditionnelles", emoji: "🗡️", searchQuery: "traditional weapons horn africa" },
          { id: "jewelry_artifacts", name: "Bijoux anciens", emoji: "📿", searchQuery: "ancient jewelry horn africa" },
          { id: "colonial_artifacts", name: "Objets coloniaux", emoji: "🧭", searchQuery: "colonial artifacts djibouti" }
        ]
      }
    ]
  },
  {
    id: 9,
    title: "Les Institutions",
    theme: "institutions",
    timeLimit: 50,
    grids: [
      {
        id: 41,
        title: "institutions_politiques",
        items: [
          { id: "presidency", name: "Présidence", emoji: "🏛️", searchQuery: "presidency djibouti government" },
          { id: "national_assembly", name: "Assemblée nationale", emoji: "🏛️", searchQuery: "national assembly djibouti" },
          { id: "cabinet", name: "Conseil des ministres", emoji: "👥", searchQuery: "cabinet ministers djibouti" },
          { id: "supreme_court", name: "Cour suprême", emoji: "⚖️", searchQuery: "supreme court djibouti" },
          { id: "constitutional_council", name: "Conseil constitutionnel", emoji: "📜", searchQuery: "constitutional council djibouti" },
          { id: "electoral_commission", name: "Commission électorale", emoji: "🗳️", searchQuery: "electoral commission djibouti" },
          { id: "local_government", name: "Gouvernement local", emoji: "🏙️", searchQuery: "local government djibouti" },
          { id: "political_parties", name: "Partis politiques", emoji: "🏢", searchQuery: "political parties djibouti" }
        ]
      },
      {
        id: 42,
        title: "forces_securite",
        items: [
          { id: "army", name: "Armée nationale", emoji: "🪖", searchQuery: "djibouti national army" },
          { id: "navy", name: "Marine", emoji: "⚓", searchQuery: "djibouti navy forces" },
          { id: "air_force", name: "Force aérienne", emoji: "✈️", searchQuery: "djibouti air force" },
          { id: "police", name: "Police nationale", emoji: "👮", searchQuery: "djibouti national police" },
          { id: "gendarmerie", name: "Gendarmerie", emoji: "👮", searchQuery: "djibouti gendarmerie" },
          { id: "coast_guard", name: "Garde-côtes", emoji: "🚤", searchQuery: "djibouti coast guard" },
          { id: "republican_guard", name: "Garde républicaine", emoji: "💂", searchQuery: "djibouti republican guard" },
          { id: "intelligence", name: "Service de renseignement", emoji: "🕵️", searchQuery: "djibouti intelligence service" }
        ]
      },
      {
        id: 43,
        title: "institutions_educatives",
        items: [
          { id: "university_djibouti", name: "Université de Djibouti", emoji: "🏫", searchQuery: "university of djibouti" },
          { id: "technical_institute", name: "Institut technique", emoji: "🏫", searchQuery: "technical institute djibouti" },
          { id: "teacher_training", name: "École normale", emoji: "👨‍🏫", searchQuery: "teacher training school djibouti" },
          { id: "vocational_center", name: "Centre de formation", emoji: "🔧", searchQuery: "vocational training center djibouti" },
          { id: "secondary_schools", name: "Lycées", emoji: "🏫", searchQuery: "secondary schools djibouti" },
          { id: "primary_schools", name: "Écoles primaires", emoji: "🏫", searchQuery: "primary schools djibouti" },
          { id: "islamic_schools", name: "Écoles coraniques", emoji: "📚", searchQuery: "islamic schools djibouti" },
          { id: "research_center", name: "Centre de recherche", emoji: "🔬", searchQuery: "research center djibouti" }
        ]
      },
      {
        id: 44,
        title: "institutions_sanitaires",
        items: [
          { id: "peltier_hospital", name: "Hôpital Peltier", emoji: "🏥", searchQuery: "peltier hospital djibouti" },
          { id: "military_hospital", name: "Hôpital militaire", emoji: "🏥", searchQuery: "military hospital djibouti" },
          { id: "health_centers", name: "Centres de santé", emoji: "🏥", searchQuery: "health centers djibouti" },
          { id: "maternity", name: "Maternité Dar El Hanan", emoji: "👶", searchQuery: "maternity hospital djibouti" },
          { id: "medical_school", name: "École de médecine", emoji: "⚕️", searchQuery: "medical school djibouti" },
          { id: "pharmacy_board", name: "Ordre des pharmaciens", emoji: "💊", searchQuery: "pharmacy board djibouti" },
          { id: "red_crescent", name: "Croissant-Rouge", emoji: "🌙", searchQuery: "red crescent djibouti" },
          { id: "health_ministry", name: "Ministère de la Santé", emoji: "🏛️", searchQuery: "health ministry djibouti" }
        ]
      },
      {
        id: 45,
        title: "organisations_internationales",
        items: [
          { id: "un_office", name: "Bureau des Nations Unies", emoji: "🇺🇳", searchQuery: "united nations office djibouti" },
          { id: "world_bank", name: "Banque mondiale", emoji: "🏦", searchQuery: "world bank office djibouti" },
          { id: "igad", name: "IGAD", emoji: "🌍", searchQuery: "igad headquarters djibouti" },
          { id: "african_union", name: "Union africaine", emoji: "🌍", searchQuery: "african union djibouti" },
          { id: "red_cross", name: "Croix-Rouge", emoji: "🩸", searchQuery: "red cross djibouti" },
          { id: "usaid", name: "USAID", emoji: "🇺🇸", searchQuery: "usaid office djibouti" },
          { id: "french_cooperation", name: "Coopération française", emoji: "🇫🇷", searchQuery: "french cooperation djibouti" },
          { id: "who", name: "OMS", emoji: "⚕️", searchQuery: "who office djibouti" }
        ]
      }
    ]
  }
];

export const LEVEL_THEMES = {
  tourism: { color: 'from-blue-500 to-cyan-500', icon: '🏖️' },
  culture: { color: 'from-purple-500 to-pink-500', icon: '🎭' },
  food: { color: 'from-orange-500 to-red-500', icon: '🍛' },
  nature: { color: 'from-green-500 to-emerald-500', icon: '🦩' },
  regions: { color: 'from-indigo-500 to-purple-500', icon: '🗺️' },
  commerce: { color: 'from-yellow-500 to-orange-500', icon: '🏪' },
  traditions: { color: 'from-rose-500 to-pink-500', icon: '💃' },
  history: { color: 'from-gray-500 to-slate-500', icon: '📜' },
  institutions: { color: 'from-teal-500 to-blue-500', icon: '🏛️' }
};
